import { makeStyles } from "@tiny/components";

export const useStyles = makeStyles(() => ({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
}));
